<template>
  <NavigationBar @toggleBar="toggleBar" />
  <AiAssistantSidebar />
  <div class="main-content" :class="{ 'main-content-small': small, 'navbar-hidden': !isNavBarVisible }">
    <Header />
    <VNotificationBlock />
    <router-view :class="{ 'router': isNavBarVisible }" />
  </div>
  <v-notification-container />
  <CookieConsentPopup v-model="cookieConsentVisible" />
  <InstructionPopup v-model="instructionPopupVisible" />
  <InvitationPopup v-model="invitationPopupVisible" />
</template>

<script>
import NavigationBar from '@/components/layout/NavigationBar.vue'
import Header from '@/components/layout/VHeader.vue'
import AiAssistantSidebar from '@/components/layout/AiAssistantSidebar.vue'
import VNotificationBlock from '@/components/layout/VNotificationBlock.vue'
import VNotificationContainer from '@/components/ui/VNotificationContainer.vue'
import { useNavigationStore } from '@/store/NavigationStore.js'
import { useThemeStore } from '@/store/ThemeStore.js'
import { useSettingsStore } from '@/store/SettingsStore.js'
import { useUserStore } from '@/store/UserStore.js'
import { useInstructionStore } from '@/store/InstructionStore.js'
import CookieConsentPopup from './components/common/CookieConsentPopup.vue'
import InstructionPopup from './components/common/InstructionPopup.vue'
import InvitationPopup from './components/common/InvitationPopup.vue'
import { useInvitationStore } from '@/store/InvitationStore.js'
import { useChatStore } from '@/store/ChatStore.js'
import { useCompanyStore } from '@/store/CompanyStore.js'
import { useNotificationStore } from '@/store/NotificationStore.js'
import { chatSocket } from '@/utils/chatSocket'
import { checkRole, getMaxRole } from '@/utils/role'
import Cookies from 'js-cookie'

export default {
  name: 'App',

  components: {
    NavigationBar,
    Header,
    VNotificationBlock,
    VNotificationContainer,
    AiAssistantSidebar,
    CookieConsentPopup,
    InstructionPopup,
    InvitationPopup
  },

  data() {
    return {
      navigatinStore: useNavigationStore(),
      themeStore: useThemeStore(),
      settingsStore: useSettingsStore(),
      userStore: useUserStore(),
      instructionStore: useInstructionStore(),
      invitationStore: useInvitationStore(),
      chatStore: useChatStore(),
      companyStore: useCompanyStore(),
      notificationStore: useNotificationStore(),
      chatFeedSub: null,
      notificationsSub: null,
      small: false,
      cookieConsentVisible: false,
    }
  },

  watch: {
    'companyStore.selectedCompanyId'(id) {
      if (id) this._initChat(id)
    }
  },

  computed: {
    isNavBarVisible() {
      return this.navigatinStore.isNavBarVisible
    },
    instructionPopupVisible: {
      get() {
        return this.instructionStore.visible
      },
      set(val) {
        if (!val) this.instructionStore.close()
      }
    },
    invitationPopupVisible: {
      get() {
        return this.invitationStore.visible
      },
      set(val) {
        if (!val) this.invitationStore.close()
      }
    }
  },

  methods: {
    toggleBar(small) {
      this.small = small
    },

    async _initChat(companyId) {
      chatSocket.connect()
      await this.chatStore.fetchChats(companyId)

      if (this.chatFeedSub) {
        chatSocket.unsubscribe(this.chatFeedSub)
        this.chatFeedSub = null
      }

      const role = getMaxRole(this.userStore.myUserInfo?.roles)
      if (checkRole(role, 'ROLE_DIRECTOR')) {
        this.chatFeedSub = chatSocket.subscribeToCompanyFeed(companyId, (msg) => {
          this.chatStore.onIncomingMessage(msg)
        })
      }

      if (!this.notificationsSub) {
        this.notificationsSub = chatSocket.subscribeToNotifications((notification) => {
          this.notificationStore.addNotification({ message: notification.text || 'Вас упомянули в чате', type: 'info' })
        })
      }
    }
  },

  async mounted() {
    // Initialize theme from store
    this.themeStore.initializeTheme()
    this.settingsStore.loadSettings()

    if (!localStorage.getItem('cookie_consent_accepted')) {
      this.cookieConsentVisible = true
    }

    if (Cookies.get('access_token')) {
      await this.userStore.fetchMyUserInfo()
      this.instructionStore.showIfNeeded()
      await this.invitationStore.showIfNeeded()

      if (!this.companyStore.selectedCompanyId) {
        await this.companyStore.fetchCompanies()
      }
      if (this.companyStore.selectedCompanyId) {
        await this._initChat(this.companyStore.selectedCompanyId)
      }
    }
  }
}
</script>
